import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20369e6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "salary pb-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "px-3 pt-3 pb-4"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500" }, "給与残高", -1))
const _hoisted_5 = { class: "text-size-32 text-weight-600" }
const _hoisted_6 = {
  key: 0,
  class: "text-mild text-size-14"
}
const _hoisted_7 = { class: "d-flex justify-content-between mt-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 mt-3" }, "\n              早期引出でエラーが発生した場合、営業日（土日祝を除く平日9:00〜18:00）で対応させていただきます。\n            ", -1))
const _hoisted_9 = {
  key: 0,
  class: "section2 d-flex justify-content-between mt-2"
}
const _hoisted_10 = { class: "flex-grow-1 d-flex align-items-center bg-white border border-outline-color mr-2 round-8" }
const _hoisted_11 = { class: "right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-12" }, "累計収入", -1))
const _hoisted_13 = { class: "text-size-14 text-weight-600" }
const _hoisted_14 = { class: "flex-grow-1 d-flex align-items-center bg-white border border-outline-color round-8" }
const _hoisted_15 = { class: "right" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-12" }, "累計引出", -1))
const _hoisted_17 = { class: "text-size-14 text-weight-600" }
const _hoisted_18 = { class: "section3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-mild text-size-14 text-weight-500 px-3 pb-2" }, "\n            入出金履歴\n          ", -1))
const _hoisted_20 = { class: "history-list border-top border-outline-color" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_23 = { class: "text-size-14 text-weight-500" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = { class: "arrow-area text-center" }
const _hoisted_26 = { class: "mt-1" }
const _hoisted_27 = { class: "text-gray-05 text-size-12" }
const _hoisted_28 = {
  key: 1,
  class: "px-3"
}
const _hoisted_29 = { class: "text-center pt-5" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-black text-size-18 text-weight-500" }, [
  /*#__PURE__*/_createTextVNode("\n            仕事をして"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("給与を受け取りましょう！\n          ")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-data-text" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "現在確認できる給与はありません")
], -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "d-flex justify-content-between" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "報酬", -1))
const _hoisted_35 = { class: "text-mild text-size-14" }
const _hoisted_36 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "交通費", -1))
const _hoisted_38 = { class: "text-mild text-size-14" }
const _hoisted_39 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "源泉徴収額", -1))
const _hoisted_41 = { class: "text-mild text-size-14" }
const _hoisted_42 = { class: "d-flex justify-content-between mt-3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-16 text-weight-500" }, "総計", -1))
const _hoisted_44 = { class: "text-blue text-size-16 text-weight-500" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "d-flex justify-content-between" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "申請額", -1))
const _hoisted_48 = { class: "text-mild text-size-14" }
const _hoisted_49 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "手数料", -1))
const _hoisted_51 = { class: "text-mild text-size-14" }
const _hoisted_52 = { class: "d-flex justify-content-between mt-3" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-16 text-weight-500" }, "振込額", -1))
const _hoisted_54 = { class: "text-blue text-size-16 text-weight-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BgWaveCard = _resolveComponent("BgWaveCard")!
  const _component_DownloadBadgeBlue = _resolveComponent("DownloadBadgeBlue")!
  const _component_UploadBadgeGreen = _resolveComponent("UploadBadgeGreen")!
  const _component_BBadge = _resolveComponent("BBadge")!
  const _component_NoSalary = _resolveComponent("NoSalary")!
  const _component_AppButtonOutline = _resolveComponent("AppButtonOutline")!
  const _component_BModal = _resolveComponent("BModal")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      給与管理\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (!_ctx.isNoData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.balance)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_BgWaveCard, { class: "section1" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("h2", _hoisted_5, "\n                ¥ " + _toDisplayString(_ctx.currency(_ctx.balance.amount)), 1),
                        _createTextVNode(),
                        (_ctx.balance.salary > 0 && _ctx.balance.scheduledSalaryTransferDate)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.toMonthDay(_ctx.balance.scheduledSalaryTransferDate)) + "\n                振込予定額 ¥ " + _toDisplayString(_ctx.currency(_ctx.balance.salary)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createTextVNode(),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_AppButton, {
                          to: { name: 'SetBank' },
                          variant: "light",
                          size: "sm",
                          class: "text-primary-dark text-weight-500 bg-gray-02 mr-2 round-4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("振込先口座を変更")
                          ], undefined, true),
                          _: 1
                        }),
                        _createTextVNode(),
                        _createVNode(_component_AppButton, {
                          to: { name: 'Withdrawal' },
                          variant: "success",
                          size: "sm",
                          class: "text-weight-500 ml-2 round-4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("早期引出")
                          ], undefined, true),
                          _: 1
                        })
                      ]),
                      _createTextVNode(),
                      _hoisted_8
                    ], undefined, true),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.balance)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_DownloadBadgeBlue, { class: "left" }),
                          _createTextVNode(),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createTextVNode(),
                            _createElementVNode("p", _hoisted_13, "\n                  ¥ " + _toDisplayString(_ctx.currency(_ctx.balance.totalIncome)), 1)
                          ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_UploadBadgeGreen, { class: "left" }),
                          _createTextVNode(),
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createTextVNode(),
                            _createElementVNode("p", _hoisted_17, "\n                  ¥ " + _toDisplayString(_ctx.currency(_ctx.balance.totalWithdrawal)), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createTextVNode(),
              _createElementVNode("ul", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.balanceHistories, (history) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: history.id,
                    class: "bg-white border-bottom border-outline-color"
                  }, [
                    _createElementVNode("div", {
                      class: "d-block p-3",
                      onClick: ($event: any) => (_ctx.onClickHistory(history))
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", _hoisted_23, [
                          _createTextVNode(_toDisplayString(_ctx.toYearMonthDay(history.createdAt)) + " ", 1),
                          _createVNode(_component_BBadge, {
                            pill: "",
                            variant: _ctx.statusLabelVariant(history),
                            class: "flex-shrink-0 text-weight-400 ml-3 mt-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.statusLabel(history)), 1)
                            ], undefined, true),
                            _: 2
                          }, 1032, ["variant"])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("p", {
                            class: _normalizeClass(_ctx.getHistoryNumClass(history))
                          }, _toDisplayString(_ctx.getTransactionSymbol(history)) + "\n                      ¥ " + _toDisplayString(_ctx.currency(_ctx.calcTotal(history))), 3),
                          _createTextVNode(),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_FeatherIcon, {
                              icon: "chevron-right",
                              size: "1x",
                              class: "text-gray-05 ml-1"
                            })
                          ])
                        ])
                      ]),
                      _createTextVNode(),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.getTransactionText(history)), 1)
                      ])
                    ], 8, _hoisted_21)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_NoSalary),
              _createTextVNode(),
              _hoisted_30
            ]),
            _createTextVNode(),
            _hoisted_31,
            _createTextVNode(),
            _createVNode(_component_AppButtonOutline, {
              to: { name: 'SetBank' },
              block: true,
              class: "text-primary-dark text-weight-500"
            }, {
              default: _withCtx(() => [
                _createTextVNode("振込先口座を変更")
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_AppButtonOutline, {
              to: { name: 'Mypage' },
              block: true,
              class: "text-primary-dark text-weight-500 mt-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode("戻る")
              ], undefined, true),
              _: 1
            })
          ]))
    ], 512), [
      [_vShow, _ctx.initialized]
    ]),
    _createTextVNode(),
    _createVNode(_component_BModal, {
      modelValue: _ctx.isShowTransferModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowTransferModal) = $event)),
      title: "給与明細",
      "hide-footer": "",
      centered: "",
      class: "history-modal"
    }, {
      default: _withCtx(() => [
        (_ctx.targetHistory)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_35, "\n            ¥\n            " + _toDisplayString(_ctx.currency(_ctx.calcReward(_ctx.targetHistory))), 1)
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_38, "\n            ¥ " + _toDisplayString(_ctx.currency(_ctx.targetHistory.optionValue)), 1)
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_41, "\n            - ¥ " + _toDisplayString(_ctx.currency(_ctx.targetHistory.withholdingTax)), 1)
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_44, "\n            ¥ " + _toDisplayString(_ctx.currency(_ctx.calcTotal(_ctx.targetHistory))), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createVNode(_component_AppButtonOutline, {
          block: "",
          class: "text-primary-dark text-weight-500 mt-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowTransferModal = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("閉じる")
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    }, 8, ["modelValue"]),
    _createTextVNode(),
    _createVNode(_component_BModal, {
      modelValue: _ctx.isShowDrawerModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isShowDrawerModal) = $event)),
      title: "給与明細",
      "hide-footer": "",
      centered: "",
      class: "history-modal"
    }, {
      default: _withCtx(() => [
        (_ctx.targetHistory)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_48, "\n            ¥\n            " + _toDisplayString(_ctx.currency(
                _ctx.targetHistory.amountExcludeOption + _ctx.targetHistory.optionValue
              )), 1)
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_51, "\n            - ¥\n            " + _toDisplayString(_ctx.currency(_ctx.targetHistory.optionValue)), 1)
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_54, "\n            ¥\n            " + _toDisplayString(_ctx.currency(_ctx.targetHistory.amountExcludeOption)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createVNode(_component_AppButtonOutline, {
          block: "",
          class: "text-primary-dark text-weight-500 mt-3",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowDrawerModal = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("閉じる")
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    }, 8, ["modelValue"]),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}